import Mainlayout from './compontents/Mainlayout/Mainlayout'

function App() {
  return (
    <Mainlayout />
  );
}

export default App;